import styled from "@emotion/styled";
import { neutralDark10 } from "../../../../constants/colors";
import { ThemeMode } from "../../../../util/theme";
import { withFocusToggleClassName } from "../../../../util/withFocusClassName";
import { menuTheme } from "../../../menu/styled/menuTheme";

export interface ComboBoxInputProps {
    themeMode: ThemeMode;
    isContentBeforeVisible?: boolean;
    isReadonly?: boolean;
}

export const ComboBoxInput = withFocusToggleClassName(styled("input")<ComboBoxInputProps>`
    display: block;
    width: 100%;
    // Override some UA styles.
    font-family: inherit;
    font-size: ${({ themeMode }) => menuTheme.fontSize(themeMode)};
    line-height: 18px;
    padding: ${({ isContentBeforeVisible }) => (isContentBeforeVisible ? "0 0 0 0" : "0 0 0 12px")};
    height: 40px;
    box-sizing: border-box;
    border-radius: 4px;
    position: relative;
    &:hover {
        border-color: ${neutralDark10};
    }

    border: 0px;
    background-color: transparent;
    cursor: inherit;

    &:focus,
    &:focus-visible {
        outline: none;
    }
`);
